import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useI18n } from "../i18n/i18n";

const STORAGE_KEY = "cloudship_privacy_ack";

export default function ConsentBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) {
        const t1 = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t1);
      }
    } catch (_) {}
  }, []);

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60] cs-glass rounded-2xl px-5 py-4 shadow-2xl"
      role="dialog"
      aria-live="polite"
    >
      <div className="flex items-start gap-4">
        <p className="text-sm text-slate-200 leading-relaxed flex-1">
          {t("consent.message")}{" "}
          <Link
            to="/datenschutz"
            className="text-sky-400 hover:text-sky-300 underline underline-offset-2"
            data-testid="consent-banner-link"
            onClick={dismiss}
          >
            {t("consent.link")}
          </Link>
          .
        </p>
        <button
          onClick={dismiss}
          className="text-slate-400 hover:text-white shrink-0"
          aria-label="Close"
          data-testid="consent-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="mt-3 flex justify-end">
        <button
          onClick={dismiss}
          className="cs-btn-primary text-xs"
          data-testid="consent-banner-accept"
        >
          {t("consent.accept")}
        </button>
      </div>
    </div>
  );
}
